import Button, { ButtonProps } from '@atlaskit/button/new';
import Tooltip from '@atlaskit/tooltip';
import React, { FC } from 'react';
import { translationKeys, useTranslation } from 'services/localization';

type OwnProps = Pick<ButtonProps, 'isDisabled' | 'onClick'>;

const GlobalUnsubscribeButton: FC<OwnProps> = ({ isDisabled, onClick }) => {
  const { translate } = useTranslation();
  return (
    <Tooltip content={translate(translationKeys.UNSUBSCRIBE_ALL_TOOLTIP_LABEL)}>
      <Button onClick={onClick} isDisabled={isDisabled} testId='global-unsubscribe-button'>
        {translate(translationKeys.UNSUBSCRIBE_ALL_BUTTON_LABEL)}
      </Button>
    </Tooltip>
  );
};

export default GlobalUnsubscribeButton;
